import { createFileRoute, Outlet } from '@tanstack/react-router'
import { useState } from 'react'

import { AppSidebar } from '@/components/app-sidebar'
import { SidebarProvider, SidebarInset, SidebarTrigger } from '@/components/ui/sidebar'
import { AdminNavigationSidebarItems } from '@/constants/navigation'
import { PreferencesCookiesKey } from '@/constants/preferences'
import { getCookiePreference } from '@/lib/cookiesPreferences'
import { getSidebarItems } from '@/utils/getSidebarItems'
import { Separator } from '@/components/ui/separator'
import ModalChangePassword from '@/components/common/Sidebar/ModalChangePassword'
import { useChangePassword } from '@/modules/auth/service/auth'
import { toast } from '@/components/common/Toast'
import { Footer } from '@/components/common'

export const Route = createFileRoute('/(dashboard)/admin')({
  component: AdminLayout,
  loader: () => {
    const initialExpanded = getCookiePreference(PreferencesCookiesKey.SIDE_BAR_EXPANDED)
    const sidebar = getSidebarItems(AdminNavigationSidebarItems)
    return { initialExpanded, sidebar }
  },
})

function AdminLayout() {
  const { initialExpanded, sidebar } = Route.useLoaderData()
  const [isOpenChangePassword, setIsOpenChangePassword] = useState(false)
  const { mutateAsync: changePassword } = useChangePassword()

  const handleChangePassword = async (currentPassword: string, newPassword: string) => {
    try {
      await changePassword({ currentPassword, newPassword })
      toast.toastSuccess('เปลี่ยนรหัสผ่านสำเร็จ')
      setIsOpenChangePassword(false)
    } catch (error) {
      toast.toastFailed('เปลี่ยนรหัสผ่านไม่สำเร็จ')
    }
  }

  return (
    <SidebarProvider defaultOpen={initialExpanded} className="h-svh max-h-svh overflow-hidden">
      <AppSidebar 
        items={sidebar}
        onChangePassword={() => setIsOpenChangePassword(true)}
      />
      <SidebarInset className="flex h-svh min-h-0 flex-col overflow-hidden">
        <header className="z-10 flex h-14 shrink-0 items-center border-b bg-background px-4 md:hidden">
          <SidebarTrigger className="-ml-1" />
        </header>
        <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden">
          <div className="app-content-scale max-w-full p-4 md:p-6 lg:p-8">
            <Outlet />
          </div>
        </div>
      </SidebarInset>
      {/* Change Password Modal */}
      <ModalChangePassword
        isOpen={isOpenChangePassword}
        onClose={() => setIsOpenChangePassword(false)}
        handleChangePassword={handleChangePassword}
      />
    </SidebarProvider>
  )
}

